import * as types from './types';

const initialState = {
  subscriptions: [],
  loading: false,
  success: false,
  fetched: false,
  fetchUserSubscriptionError: false,
  updateUserSubscriptionError: false
};

function userSubscriptionsReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_USER_SUBSCRIPTION:
      return {
        ...state,
        loading: true
      };

    case types.GET_USER_SUBSCRIPTION_COMPLETED:
      return {
        ...state,
        loading: false,
        subscriptions: action.payload,
        fetched: true
      };

    case types.GET_USER_SUBSCRIPTION_FAILED:
      return {
        ...state,
        loading: false,
        fetched: true,
        fetchUserSubscriptionError: true
      };

    case types.UPDATE_USER_SUBSCRIPTION:
      return {
        ...state,
        loading: true
      };

    case types.UPDATE_USER_SUBSCRIPTION_COMPLETED:
      return {
        ...state,
        loading: false,
        success: true
      };

    case types.UPDATE_USER_SUBSCRIPTION_FAILED:
      return {
        ...state,
        loading: false,
        updateUserSubscriptionError: true
      };

    default:
      return state;
  }
}

export default userSubscriptionsReducer;
